export default {
  newDesign: true,
  title:
    "Çocuğunuzun ilgilerini faydalı becerilere nasıl dönüştürebileceğinizi öğrenmek ister misiniz? | Kodland",
  parameters: {
    landing_id: "TrQuCoHab",
    segment: 11,
    success_page: "success_long",
  },
  downtimeUrl: "http://kodland.org/tr",
  startPage: {
    title:
      "Çocuğunuzun ilgilerini faydalı becerilere nasıl dönüştürebileceğinizi öğrenmek ister misiniz?",
    subtitle:
      "Sadece 5 dakikada sonuç alacaksınız!<br>Soruları cevaplayın ve çocuğunuzun başarılı bir geleceği için hazır bir yol haritası elde edin.",
    image: {
      url: "/welcome/turkey_coding_habilities_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/turkey_coding_habilities_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Başla ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "",
      type: "age",
      button: "",
    },
    2: {
      question: "Çocuğunuz günde ne kadar süreyle dijital cihazlar kullanıyor?",
      answers: [
        "Bir saatten az 🕒",
        "1–2 saat 📱",
        "3–4 saat 💻",
        "5 saatten fazla ⏳",
        "Cihaz kullanmıyor 🚫",
      ],
    },
    3: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 2, answer: "Bir saatten az 🕒" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_coding_habilities_s4.png",
            subtitle:
              "Tebrikler, çocuğunuz dünya çapında önerilen standartlara uygun! Testin sonunda, çocuğunuzun ekran süresini nasıl verimli hale getirebileceğinizi sizinle paylaşacağız.",
            button: "Her şey net 👌",
          },
        },
        {
          condition: [{ step: 2, answer: "1–2 saat 📱" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_coding_habilities_s4.png",
            subtitle:
              "Tebrikler, çocuğunuz dünya çapında önerilen standartlara uygun! Testin sonunda, çocuğunuzun ekran süresini nasıl verimli hale getirebileceğinizi sizinle paylaşacağız.",
            button: "Her şey net 👌",
          },
        },
        {
          condition: [{ step: 2, answer: "3–4 saat 💻" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_coding_habilities_s4.png",
            subtitle:
              "Şu anda 8–17 yaş arası çocukların günde en fazla 1–2 saat ekran başında vakit geçirmesi önerilmektedir! Testin sonunda, çocuğunuzun ekran süresini nasıl verimli hale getirebileceğinizi sizinle paylaşacağız.",
            button: "Her şey net 👌",
          },
        },
        {
          condition: [{ step: 2, answer: "5 saatten fazla ⏳" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_coding_habilities_s4.png",
            subtitle:
              "Şu anda 8–17 yaş arası çocukların günde en fazla 1–2 saat ekran başında vakit geçirmesi önerilmektedir! Testin sonunda, çocuğunuzun ekran süresini nasıl verimli hale getirebileceğinizi sizinle paylaşacağız.",
            button: "Her şey net 👌",
          },
        },
        {
          default: true,
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_coding_habilities_s4.png",
            subtitle:
              "Bilgisayar ve akıllı telefon, zararlı gibi görünse de, modern yaşamın, başarılı bir eğitimin ve kariyerin ayrılmaz bir parçasıdır.",
            button: "Her şey net 👌",
          },
        },
      ],
    },
    4: {
      question:
        "Çocuğunuz bilgisayarlar, uygulamalar veya temel internet işlemleri gibi teknolojileri kullanırken rahat mı?",
      answers: [
        "Evet, çok rahat ve sık kullanıyor 💻✔️",
        "Temel işlemleri biliyor, zorlanınca destek gerekiyor 🖱️",
        "Hayır, teknolojiyle çok aşina değil 🚫",
      ],
    },
    5: {
      question: "Çocuğunuzun en çok hangi hobisi var?",
      answers: [
        "🎌 Anime ve manga",
        "📺 Çizgi film izlemek",
        "🎨 Kağıt veya tablet üzerinde çizim yapmak",
        "🎮 Bilgisayar ve mobil oyunlar",
        "📝 Sosyal medyada blog yazmak",
      ],
    },
    6: {
      question: "Çocuğunuzda hangi becerilerin gelişmesini istersiniz?",
      answers: [
        "🤝 Sosyal beceriler, iletişim ve özgüven",
        "🎨 Yaratıcı beceriler: yaratıcılık, güzel şeyler tasarlayıp üretme",
        "💻 Güncel yazılımlar, güçlü teknik beceriler",
        "🙂 Diğer",
      ],
    },
    7: {
      question: "Çocuğunuzda hangi becerilerin gelişmesini istersiniz?",
      answers: [
        "🛠️ Teknik dersler",
        "🎨 Yaratıcı dersler",
        "🤝 Sosyal dersler",
        "⚽ Fiziksel aktivitelerle ilgili dersler",
        "❓ Emin değilim",
      ],
    },
    8: {
      question: "Çocuğunuzda hangi becerilerin gelişmesini istersiniz?",
      answers: [
        "📵 Faydalı aktivitelerle ekran süresi azalacak",
        "🚀 Gelecekteki kariyerine erken adım atacak",
        "🎨 Hobisini geliştirip yaratıcı olacak",
        "🤝 Sosyalleşecek ve topluluğa katılacak",
        "🙂 Diğer",
      ],
    },
    9: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle:
        "Verdiğiniz yanıtlara göre, çocuğunuzun tutkularını nasıl daha anlamlı bir geleceğe dönüştürebileceğinize dair önerilerimiz var.",
      button: " İzle ",
    },
    10: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 5, answer: "🎌 Anime ve manga" }],
          data: {
            typeInfo: "noQuestions",
            subtitle:
              "🎨 Anime ve tasarıma ilgi duyan çocuklar için özel fırsat!<br><br>Kodland’da online grafik tasarım ve animasyon dersini ÜCRETSİZ dene!<br>Çocuğunuz:<br>✔️ Kendi animasyonlarını yaratmayı öğrenir<br>✔️ Takım çalışması ve iletişim becerilerini geliştirir<br>✔️ Özgüven kazanır<br>✔️ Geleceğin mesleklerine hazırlanır<br><br>🧒 İlk dersi hemen ücretsiz dene!",
            button: "Ücretsiz derse katıl",
          },
        },
        {
          condition: [{ step: 5, answer: "📺 Çizgi film izlemek" }],
          data: {
            typeInfo: "noQuestions",
            subtitle:
              "🎬 Çizgi film izlemeyi seven çocuklara özel!<br>Kodland’da online grafik tasarım ve animasyon dersini ÜCRETSİZ dene!<br><br>Çocuğunuz:<br>🎨 Kendi çizgi filmlerini ve karakterlerini tasarlamayı öğrenir<br>🤝 Takım çalışması yapar, iletişim becerileri kazanır<br>💪 Özgüven ve bağımsızlık geliştirir<br>💻 Bilgisayar programlarıyla geleceğe hazırlanır<br><br>🧒 Testi tamamla, ilk dersi ücretsiz al!",
            button: "Ücretsiz derse katıl",
          },
        },
        {
          condition: [
            { step: 5, answer: "🎨 Kağıt veya tablet üzerinde çizim yapmak" },
          ],
          data: {
            typeInfo: "noQuestions",
            subtitle:
              "🎨 Çizim yapmayı seven çocuklara özel fırsat!<br>Kodland’da online grafik tasarım ve animasyon eğitimini ÜCRETSİZ dene!<br><br>Çocuğunuz bu eğitimle:<br>✨ Kendi çizgi film ve karakterlerini tasarlamayı öğrenir<br>🤝 Takım çalışması ve iletişim becerilerini geliştirir<br>💪 Özgüven kazanır<br>💻 Bilgisayar programlarını kullanarak geleceğe hazırlanır<br><br>🧒 Testi tamamla, ilk ders ücretsiz!",
            button: "Ücretsiz derse katıl",
          },
        },
        {
          condition: [{ step: 5, answer: "🎮 Bilgisayar ve mobil oyunlar" }],
          data: {
            typeInfo: "noQuestions",
            subtitle:
              "🎮 Bilgisayar oyunlarını seven yaratıcı çocuklara özel!<br>Kodland’da online grafik tasarım ve animasyon eğitimini ÜCRETSİZ dene!<br><br>Çocuğunuz bu eğitimle:<br>🎨 Kendi karakterlerini ve çizgi filmlerini tasarlamayı öğrenir<br>🤝 Takım çalışması ve iletişim becerileri kazanır<br>💪 Özgüven geliştirir<br>💻 Bilgisayar programlarını öğrenerek geleceğe hazırlanır<br><br>🧒 Testi tamamla, ilk dersi ücretsiz al!",
            button: "Ücretsiz derse katıl",
          },
        },
        {
          default: true,
          data: {
            typeInfo: "noQuestions",
            subtitle:
              "📱 Sosyal medyada vakit geçirmeyi seven yaratıcı çocuklara özel!<br>Kodland’da online grafik tasarım ve animasyon eğitimini ÜCRETSİZ dene!<br><br>Çocuğunuz bu eğitimle:<br>🎨 Kendi illüstrasyon ve karakterlerini tasarlamayı öğrenir<br>🤝 Takım çalışması ve iletişim becerilerini geliştirir<br>💪 Özgüven ve bağımsızlık kazanır<br>💻 Bilgisayar programlarıyla geleceğe hazırlanır<br><br>🧒 Testi tamamla, ilk ders ücretsiz!",
            button: "Ücretsiz derse katıl",
          },
        },
      ],
    },
    11: {
      question: "Çocuğunuz ders çalışmak için bir bilgisayara erişebiliyor mu?",
      answers: [
        "✅ Evet, kendi cihazı var",
        "👨‍👩‍👧‍👦 Evet, ama başkalarıyla paylaşıyor",
        {
          answer: "❌ Hayır, düzenli erişimi yok",
          stopAnswer: true,
        },
      ],
    },
    12: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    13: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    14: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    15: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    16: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
